import classNames from 'classnames';
import PropTypes from 'prop-types';
import type React from 'react';
import type BadgeType from '../../../../../../types/Badge';
import { getIconImageUrlWithDefault, isCustomIcon } from '../../../../services/Badge';
import styles from './style.m.less';

type Props = {
    badge?: Partial<BadgeType>;
    size?: string;
    ratio?: number;
    className?: string;
    baseUrl?: string;
};

const propTypes = {
    badge: PropTypes.object,
    size: PropTypes.string,
    ratio: PropTypes.number,
    className: PropTypes.string,
};

const CustomBadge = ({
    image,
    altText,
    sizeStyle,
    className,
}: {
    image: string;
    altText?: string;
    sizeStyle?: React.CSSProperties;
    className?: string;
}) => <img src={image} style={sizeStyle} alt={altText} className={classNames(styles.customBadgeImage, className)} />;

const setSizeStyle = (size: string) => ({
    width: size,
    height: size,
});

export default function Badge({ baseUrl = '', badge, size = 'auto', className }: Props) {
    const badgeUrl = baseUrl + getIconImageUrlWithDefault(badge?.icon);
    const sizeStyle = setSizeStyle(size);
    const altText = 'Badge: ' + badge?.name;

    if (badge && isCustomIcon(badge.icon)) {
        return <CustomBadge sizeStyle={sizeStyle} altText={altText} image={badgeUrl} className={className} />;
    } else {
        return (
            <img style={sizeStyle} src={badgeUrl} alt={altText} className={classNames(styles.badgeImage, className)} />
        );
    }
}

export function StandaloneCustomBadge({ image, size }: { image: string; size: string }) {
    return (
        <div style={setSizeStyle(size)}>
            <CustomBadge image={image} />
        </div>
    );
}

Badge.propTypes = propTypes;
